import {ComparisonOperator, Condition, FieldName} from "../../@types/Query";
import SelectControl from "../SelectControl/SelectControl";
import InputControl from "../InputControl/InputControl";

type Props = {
    condition: Condition
    onChange: (condition: Condition) => void
}

const fieldNames: FieldName[] = [
    "content_id",
    "event_type",
    "content_url",
    "parent_id",
    "parent_url",
    "content_type",
    "variant",
    "viewmode",
    "pagetype",
    "region",
    "grid_container_number",
    "grid_container_name",
    "grid_slot_number",
    "grid_box_number",
    "grid_box_type",
    "list_number",
    "screen_number",
    "breakpoint",
    "referer_domain",
    "referer_path",
    "tag",
];

const comparisonOperators: ComparisonOperator[] = [
    "=",
    ">",
    ">=",
    "<",
    "<=",
    "!=",
    "IN",
    "NOT IN",
    "IS NULL",
    "IS NOT NULL",
];

const ConditionControl = (
    {
        condition,
        onChange
    }: Props
) => {
    const handleFieldChange = (field: FieldName) => {
        onChange({...condition, field: field});
    }
    const handleOperationChange = (operation: ComparisonOperator) => {
        onChange({...condition, compare: operation});
    }
    const handleValueChange = (value: string|number) => {
        onChange({...condition, value})
    }
    return (
        <div>

            <SelectControl<FieldName>
                value={condition.field}
                options={fieldNames.map(field => ({value: field, label: field}))}
                onChange={handleFieldChange} />

            <SelectControl<ComparisonOperator>
                value={condition.compare}
                options={comparisonOperators.map(op=>({value:op, label:op}))}
                onChange={handleOperationChange}
            />
            {
                typeof condition.value == "string"  ?
                    <InputControl
                        value={condition.value}
                        onChange={(value) => handleValueChange(value)}
                    />
                    :
                    null
            }
            {
                typeof condition.value == "number"  ?
                    <InputControl
                        type="number"
                        value={`${condition.value}`}
                        onChange={(value) => handleValueChange(parseInt(value))}
                    />
                    :
                    null
            }

        </div>
    )
}

export default ConditionControl;
